/* import __COLOCATED_TEMPLATE__ from './control.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import dayjs from 'dayjs';

export default class ControlTimingComponent extends Component 
{
	@tracked enteredBib = "";
	@tracked entry = null;
	@tracked entryTime = null;
	@tracked color = null;
	
	@service store;
	@service ajax;
	
	tpId = 2066;
	
	@action
	async enter()
	{
		this.entry = null;
		this.entryTime = new Date();
		this.color = null;
		
		const bib = parseInt(this.enteredBib);
		const entries = await this.args.event.get('entries');
		for(const entry of entries)
		{
			if(entry.bib == bib)
			{
				const entryRef = this.store.getReference('entry', entry.id);
				await entryRef.reload();
				
				this.entry = entry;
			}
		}
		if(this.entry)
		{
			const startTime = (await this.entry.get('StartTimingRecordId')).assignedStartTime;
			const diff = startTime-this.entryTime
			
			this.color = "bg-success";
			if(diff < (10*60*1000))
			{
				this.color = "bg-warning";
			}
			if(diff < (5*60*1000))
			{
				this.color = "bg-danger";
			}
		
			let response = await this.ajax.request("/events/"+this.args.event.get('id')+"/intermediateTimingPoint/"+this.tpId+"/enterTime/"+this.entryTime.getTime()+"/bib/"+this.entry.bib);
			//if(response.error != null)
			//	alert(response.error);
		

		}
		
		this.enteredBib = "";
	}
	
	@action
	clear()
	{
		this.enteredBib = "";
		this.entry = null;
		this.color = null;
	}
	
	@action
	addDigit(digit)
	{
		this.enteredBib = this.enteredBib+digit;
	}
}

